import { render } from "./CTA.vue?vue&type=template&id=5dc6cb31"
import script from "./CTA.vue?vue&type=script&lang=js"
export * from "./CTA.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__